module.exports = __webpack_public_path__ + "img/nexultra-uv-active-icon.d41b14ff.svg";